import { render, staticRenderFns } from "./TemplateAccordion.vue?vue&type=template&id=efb61c44&scoped=true"
import script from "./TemplateAccordion.vue?vue&type=script&lang=js"
export * from "./TemplateAccordion.vue?vue&type=script&lang=js"
import style0 from "./TemplateAccordion.vue?vue&type=style&index=0&id=efb61c44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb61c44",
  null
  
)

export default component.exports